// UserPreferenceContext.js
import React, {
  createContext,
  useContext,
  useReducer,
  useCallback,
} from "react";

const initialUserPreferences = {
  theme: "light", // or 'dark'
  language: "en",
  notifications: true,
};

const UserPreferencesContext = createContext(initialUserPreferences);

const userPreferencesReducer = (state, action) => {
  switch (action.type) {
    case "SET_PREFERENCES":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export const UserPreferencesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    userPreferencesReducer,
    initialUserPreferences
  );

  const setPreferences = (preferences) => {
    dispatch({ type: "SET_PREFERENCES", payload: preferences });
  };

  // If needed, you can add a fetch function for preferences:
  const fetchPreferences = useCallback(async () => {
    try {
      const response = await fetch("/api/preferences"); // Adjust endpoint accordingly.
      if (!response.ok) {
        throw new Error("Failed to fetch preferences.");
      }
      const data = await response.json();
      dispatch({ type: "SET_PREFERENCES", payload: data });
    } catch (error) {
      console.error("Error fetching preferences:", error);
    }
  }, []);

  return (
    <UserPreferencesContext.Provider
      value={{ state, dispatch, setPreferences, fetchPreferences }}
    >
      {children}
    </UserPreferencesContext.Provider>
  );
};

export const usePreferences = () => useContext(UserPreferencesContext);
